import { lazy } from "react";

const CommonLayout = lazy(() => import("../layouts/CommonLayout.jsx"));

const ProductHomeView = lazy(() => import("../views/product/ProductHomeView.jsx"));
const ProductDetailsHomeView = lazy(() => import("../views/product/details/ProductDetailsHomeView.jsx"));

const PurchaseOrdersHomeView = lazy(() => import("../views/purchaseOrders/PurchaseOrdersHomeView.jsx"));
const OrdersHomeView = lazy(() => import("../views/purchaseOrders/orders/PurchaseOrderView.jsx"));

const BuyersHomeView = lazy(() => import("../views/buyers/BuyersHomeView.jsx"));

const TrackHomeView = lazy(() => import("../views/track/TrackHomeView.jsx"));

const SettingsHomeView = lazy(() => import("../views/settings/SettingsHomeView.jsx"));

const NoAccessErrorView = lazy(() => import("../views/error/NoAccessErrorView.jsx"));

const ThemeRoutes = [
    {
        path: "/",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <ProductHomeView /> },
            { path: "/product/*", exact: true, element: <ProductDetailsHomeView /> },
        ],
    },
    {
        path: "/p_orders",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <PurchaseOrdersHomeView /> },
            { path: "/p_orders/*", exact: true, element: <OrdersHomeView /> },
        ],
    },

    {
        path: "/buyers",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <BuyersHomeView /> },
        ],
    },


    {
        path: "/track",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <TrackHomeView /> },
        ],
    },
    
    {
        path: "/settings",
        element: <CommonLayout />,
        children: [
            { path: "", exact: true, element: <SettingsHomeView /> },
        ],
    },
    {
        path: "/error",
        element: <CommonLayout />,
        children: [
            { path: "/error/noaccess", exact: true, element: <NoAccessErrorView /> }
        ],
    },
]
export default ThemeRoutes;